export default __webpack_public_path__ + "static/media/beyond_bg.09878f7a.png";